export const ERROR_MESSAGES = {
    INTL_IS_NOT_DEFINED: 'Intl is not defined',
};
